import { AhuType } from "../models/unitType";

export const sizeOfUnitMapping = {
    0: "Missing value",
    1: "R 03",
    2: "R 05",
    3: "R 06",
    4: "R 09",
    5: "R 12",
    6: "P 03",
    7: "P 05",
    8: "P 06",
    9: "P 09",
    10: "P 12",
    11: "E 03",
    12: "E 05",
    13: "E 06",
    14: "E 09",
    15: "E 12",
    17: "06.06",
    23: "09.06",
    25: "12.09",
    27: "15.10",
    32: "21.13",
    36: "24.15",
    37: "24.18",
    68: "09.09",
    70: "15.12",
    71: "18.12",
    72: "24.13",
    76: "09.06",
    77: "09.09",
    78: "12.09",
    79: "15.10",
    80: "15.12",
    81: "18.12",
    82: "21.13",
    83: "24.13",
    84: "24.15",
    85: "24.18",
    86: "21.18",
    87: "24.18",
    88: "24.21",
    89: "27.21",
    90: "27.24",
    91: "30.24",
    92: "33.24",
    93: "36.24",
    94: "42.24",
    95: "45.24",
    96: "PV 03",
    97: "PV 05",
    98: "PV 06",
    99: "PV 09",
    100: "PV 12",
    102: "EV 03",
    103: "EV 05",
    105: "EV 06",
    106: "EV 09",
    107: "EV 12",
};

export const unitTypeReverseMapping = {
    "Compact:Prime": AhuType.COMPACT,
    "Compact:Prime Vertical": AhuType.COMPACT_VERTICAL,
    "Energy:Prime Standard": AhuType.ENERGY_PRIME_STANDARD,
    "Energy:Prime Genius": AhuType.ENERGY_PRIME_GENIUS,
    "Aqua:Prime Standard": AhuType.AQUA_PRIME_STANDARD,
    "Aqua:Prime Genius": AhuType.AQUA_PRIME_GENIUS,
    "Line:Prime": AhuType.LINE_PRIME,
};
